export default __webpack_public_path__ + "static/media/HOSxPost_1.38b5f6dc.jpg";